import components from '../../components'

import { GAP, PADDING, WIDTH as WIDTHPdf } from 'helpers/reports/constants'

import palette from 'theme/palette'

const counter = ({ pdf, title, value, startY, rightSided = false }) => {
  const WIDTH = WIDTHPdf(pdf)

  const halfTableWidth = (WIDTH - PADDING * 3) / 2 + GAP

  const tableMargin = rightSided
    ? { left: (WIDTH - PADDING * 2) / 2 + GAP * 0.9 }
    : PADDING

  return components.table(
    pdf,
    [[title]],
    [[value]],
    startY,
    0,
    tableMargin,
    true,
    {
      0: {
        font: 'Roboto-Bold',
        fontSize: 24,
        fontStyle: 'bold',
        cellWidth: 0.45 * WIDTH - PADDING / 2,
        minCellHeight: PADDING,
        halign: 'center',
        valign: 'middle',
      },
    },
    {
      textColor: palette.white,
      font: 'Roboto-Bold',
      fillColor: palette.primary.main,
      cellPadding: 6,
      halign: 'center',
    },
    10,
    () => {},
    'grid',
    halfTableWidth,
  )
}

export default counter
